import { isMainnet } from "@/constants/flags.constant";

/**
 * A centralized object for managing core navigation and infrastructure links used across the application.
 *
 * Acts as a single source of truth for internal routes and external documentation references,
 * simplifying updates and ensuring consistency throughout the app.
 *
 * Reduces the risk of outdated or hard-coded URLs when routes or external resources are modified.
 *
 * The `isEnvMainnet` function is used to determine whether the application is running in a mainnet environment.
 * It dynamically adjusts certain links, such as the `BLOCK_SCANNER`, to point to the appropriate mainnet or testnet resources.
 */
export const LINKS = {
  APP: {
    ROOT: "/",
    BLESS_BRIDGE: "/bridge",
    BRIDGE_SCANNER: isMainnet
      ? "/bridge-scanner/mainnet"
      : "/bridge-scanner/testnet",
    DISPENSER: "/dispenser",
    ETHEREALS: "/ethereals",
    MOD_PERMS: "/modular-permissions",
    MINTER: "/cross-chain-minter",
    BLOCK_SCANNER: isMainnet
      ? "https://blessnet.calderaexplorer.xyz"
      : "https://blessnet-sepolia-testnet.explorer.caldera.xyz",
  },
  DOC: {
    TECHNICAL: "https://docs.bless.net/tech/technical-reference",
    GENERAL: "https://docs.bless.net/",
    WHITEPAPER: "https://docs.bless.net/papers-and-articles/whitepaper",
    SERVICES: {
      DISPENSER: "https://docs.bless.net/bless-token/dispenser",
    },
    REFERENCES: {
      SUPPORTED_CHAINS: "https://docs.bless.net/reference/supported-chains",
      ATTESTATIONS: "https://docs.bless.net/blessnet-apps/attestations",
    },
  },
  KEY_APP: {
    MODULAR_PERMISSIONS: "/key-apps/modular-permissions",
    ETHEREALS: "/key-apps/ethereals",
    MIRRORS: "/key-apps/mirrors",
    ATTESTATIONS: "/key-apps/attestations",
    TRANSACTION_POOL: "/key-apps/transaction-pool",
    BLESS_TOKEN: "/key-apps/bless-token",
  },
  SOCIAL: {
    X: "https://x.com/blessdotnet",
    GITHUB: "https://github.com/bless-net",
  },
};
